exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Basemap {\n    float: left;\n    width: 120px;\n    margin-left: 12px;\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 90px;\n}\n\n.Basemap-image-container {\n    position: relative;\n    height: 56px;\n    width: 100%;\n    margin-top: 4px;\n    overflow: hidden;\n}\n\n.Basemap-image {\n    position: absolute;\n    clip: rect(64px, 256px, 192px, 0);\n    width: 100%;\n    top: -64px;\n}\n\n.Basemap-no-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    line-height: 56px;\n}\n\n.Basemap-name {\n    font-size: 12px;\n    color: #333;\n    padding-top: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/basemaps/Basemap.css
// module id = 998
// module chunks = 0